import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import "./assets/css/tailwind.css";
import "./assets/css/material.css";
import ScrollToTop from "./components/scroll-to-top";
import "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <HashRouter>
    <App />
    <ScrollToTop />
  </HashRouter>
);

reportWebVitals();
